<template>
    <b-modal ref="profile_modal" size="xl" bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>
        
        <template v-slot:modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>
        
        <div id="panel_users_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
                    <span class="fw-300">ID:{{this.doc.id}}</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>
            
            <div class="p-4">
                <b-overlay :show="is_load" rounded="sm" >
                    
                    <label for="reason_number">документ підстава (при наявності)</label>
                    
                    <v-select multiple v-model="doc.links_docs"
                              @search="onSearch"
                              @input="push_reason_str"
                              class="imc_reasons"
                              label="number"
                              :filterable="false"
                              :options=multi_reasons  >
                        <template slot="no-options">
                            Починайте вводити номер службової
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.number }}
                                <small >{{option.title}}</small>
                            </div>
                        </template>
                    </v-select>
                </b-overlay>
            </div>
        </div>
        
        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">
                
                <button type="button" v-on:click="close_modal" class="btn btn-secondary waves-effect waves-themed">
                    Закрити
                </button>
                
                <button type="button" v-on:click="save_links" class="btn btn-primary waves-effect waves-themed">
                    Зберегти
                </button>
            </div>
        </template>
    </b-modal>
</template>


<script>
import vSelect from 'vue-select'

export default {
    name: "mem_links_edit",
    
    components: {
        vSelect
    },
    created() {
        EventBus.$on('load_links_editor',this.load_links)
    },
    
    data() {
        return {
            multi_reasons : [],
            modal_position : "left",
            is_show_modal: false,
            is_load: false,
            doc: {
                id: 0,
                links_docs : [],
            },
        }
    },
    
    methods : {
        
        onSearch(search, loading) {
            if(search.length > 2) {
                loading(true);
                this.search(loading, search);
            }
        },
        
        push_reason_str (cur_val) {
            let str = "";
            let nmb_str = [];
            
            this.doc.links_docs.map(item => {
                nmb_str.push(item.number);
            });
            this.reason_number = nmb_str.join(";");
        },
        
        async search(loading, search) {
            await api.get('/memorandum/items/search/' + search).then(({data}) => {
                loading(false);
                this.multi_reasons = [];
                if (data.status == "operation_success") {
                    this.multi_reasons = data.data;
                }
                
            }).catch(err => {
                this.multi_reasons = [];
                loading(false);
            });
        },
        
        async load_links(event) {
            
            let id = event.mem_id;
            this.doc.id = id;
            this.is_load = true;
            IMC_CORE.showloading();
            
            await api.get('/memorandums/' + id + '/links/own').then(({data}) => {
                this.is_show_modal = true;
                if (data.status === "operation_success") {
                    this.doc.links_docs = data.data;
                }
            }).catch(err => {
                console.log(err);
                if (err.response && err.response.hasOwnProperty('data')) {
                    EventBus.$emit('show_toast', {
                        err: err.response.data.message,
                        type: "danger",
                        title: err.response.data.status
                    });
                } else {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                }
            })
            .finally(() => {
                IMC_CORE.hideloading();
                this.is_load = false;
            });
        },
        
        async save_links() {
            IMC_CORE.showloading();
            await api.put('/memorandums/' + this.doc.id + '/links',this.doc.links_docs).then(({data}) => {
                this.close();
                window.location.reload();
            }).catch(err => {
                if (err.response && err.response.hasOwnProperty('data')) {
                    EventBus.$emit('show_toast', {
                        err: err.response.data.message,
                        type: "danger",
                        title: err.response.data.status
                    });
                } else {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                }
            })
            .finally(() => {
                EventBus.$emit("reload_mem", {"mem_id": this.doc.id});
                IMC_CORE.hideloading();
            });
        },
        
        close_modal() {
            this.close();
        },
        
        close() {
            this.doc.id = 0;
            this.doc.links_docs = [];
            this.is_show_modal = false;
        },
        
    },
    
    computed : {
        
        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-xl";
            }
            
            return "modal-dialog-right modal-xl";
        },
    }
    
    
}
</script>

<style scoped>

</style>